import React from "react";


const SurveyPDF = ({ data }) => {
  const customer = data;
  const survey = data?.surveys?.[0];
  const details = data?.survey_details;
  console.log("**********************hello",data)

  const formatLabel = (key) => {
    return key.replace(/_/g, ' ').replace(/([A-Z])/g, ' $1').replace(/\b\w/g, (c) => c.toUpperCase());
  };
  return (
    <div id="survey-pdf" style={{ padding: 20, fontSize: 12, fontFamily: "Arial" }}>
      
      {/* HEADER */}
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>FCI MASTER REPORT</h2>
        <p style={{ margin: 0 }}>Survey Report</p>
      </div>

      {/* CUSTOMER INFO */}
      <table border="1" cellPadding="6" width="100%" style={{ marginBottom: 15,tableLayout: "fixed",wordWrap: "break-word" }}>
        <tbody>
          <tr>
            <td style={{ wordBreak: "break-word" }}><b>Customer Name</b></td>
            <td style={{ wordBreak: "break-word" }}>{customer?.pb_full_name}</td>
            <td style={{ wordBreak: "break-word" }}><b>Customer ID</b></td>
            <td style={{ wordBreak: "break-word" }}>{customer?.id}</td>
          </tr>
          <tr>
            <td style={{ wordBreak: "break-word" }}><b>Product</b></td>
            <td style={{ wordBreak: "break-word" }}>{customer?.lead_type}</td>
            <td style={{ wordBreak: "break-word" }}><b>Generated On</b></td>
            <td style={{ wordBreak: "break-word" }}>{customer?.request_created}</td>
          </tr>
          <tr>
            <td style={{ wordBreak: "break-word" }}><b>Generated By</b></td>
            <td style={{ wordBreak: "break-word" }}>{customer?.created_by_name}</td>
            <td style={{ wordBreak: "break-word" }}><b>Total Surveys</b></td>
            <td style={{ wordBreak: "break-word" }}>{customer?.surveys?.length || 0}</td>
          </tr>
        </tbody>
      </table>

      {/* SURVEY INFO */}
       <div style={{ textAlign: "center", marginBottom: 20 }}>
        <h2>{survey?.surveyType?.name}</h2>
      </div>

      {details?.borrower_information && (
        <>
            <h3>Borrower Information</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.borrower_information).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.borrower_information)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.contact_details && (
        <>
            <h3>Contact Details</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.contact_details).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.contact_details)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.source_of_income && (
        <>
            <h3>Source of Income</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.source_of_income).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.source_of_income)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.residence_info && (
        <>
            <h3>Residence Info</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.residence_info).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.residence_info)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.household_expenses_info && (
        <>
            <h3>Household Expenses Info</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                   {Object.entries(details.household_expenses_info).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.household_expenses_info)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.neighborhood && (
        <>
            <h3>Neighbour Info</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.neighborhood).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.neighborhood)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.existing_loans && (
        <>
            <h3>Existing Loans</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.existing_loans).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.existing_loans)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.assets && (
        <>
            <h3>Assets</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.assets).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.assets)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.remarsk && (
        <>
            <h3>Remarks</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.remarsk).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.remarsk)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.informants && (
        <>
            <h3>Informants</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.informants).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.informants)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.company_details && (
        <>
            <h3>Company Details</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.company_details).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.company_details)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.employee_details && (
        <>
            <h3>Employee Details</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.employee_details).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.employee_details)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.business_information && (
        <>
            <h3>Business Information</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.business_information).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.business_information)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.operations_history && (
        <>
            <h3>Operations History</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.operations_history).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.operations_history)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.number_of_employees && (
        <>
            <h3>Number of Employees</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.number_of_employees).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.number_of_employees)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.facilities && (
        <>
            <h3>Facilities</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.facilities).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.facilities)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.financials && (
        <>
            <h3>Financials</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.financials).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.financials)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.business_expense && (
        <>
            <h3>Business Expense</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.business_expense).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.business_expense)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.observations && (
        <>
            <h3>Observations</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.observations).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.observations)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.trade_check_info && (
        <>
            <h3>Trade Check Info</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.trade_check_info).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.trade_check_info)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.trade_reference_info && (
        <>
            <h3>Trade Reference Info</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.trade_reference_info).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.trade_reference_info)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.transaction_history && (
        <>
            <h3>Transaction History</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.transaction_history).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.transaction_history)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.motor_vehicle_report && (
        <>
            <h3>Motor Vehicle Report</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.motor_vehicle_report).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.motor_vehicle_report)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.vehicle_details && (
        <>
            <h3>Vehicle Details</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.vehicle_details).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.vehicle_details)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.exterior_parts && (
        <>
            <h3>Exterior Parts</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.exterior_parts).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.exterior_parts)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.interior_parts && (
        <>
            <h3>Interior Parts</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.interior_parts).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.interior_parts)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.mechanical_parts && (
        <>
            <h3>Mechanical Parts</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.mechanical_parts).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.mechanical_parts)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.electrical_system && (
        <>
            <h3>Electrical System</h3>
            <table border="1" cellPadding="6" width="100%" style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.electrical_system).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.electrical_system)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {details?.documentation && (
        <>
            <h3>Documentation</h3>
            <table border="1" cellPadding="6" width="100%"style={{tableLayout: "fixed",wordWrap: "break-word"}}>
            <tbody>
                {Object.entries(details.documentation).map(([key, value], index) => {
                
                // Create rows with 2 fields per row (4 columns)
                if (index % 2 === 0) {
                    const next = Object.entries(details.documentation)[index + 1];

                    return (
                    <tr key={key}>
                        <td style={{ wordBreak: "break-word" }}><b>{formatLabel(key)}</b></td>
                        <td style={{ wordBreak: "break-word" }}>{value || '-'}</td>

                        {next ? (
                        <>
                            <td style={{ wordBreak: "break-word" }}><b>{formatLabel(next[0])}</b></td>
                            <td style={{ wordBreak: "break-word" }}>{next[1] || '-'}</td>
                        </>
                        ) : (
                        <td style={{ wordBreak: "break-word" }} colSpan="2"></td>
                        )}
                    </tr>
                    );
                }

                return null;
                })}
            </tbody>
            </table>
        </>
      )}

      {/* PAGE BREAK */}
      <div style={{ pageBreakBefore: "always" }} />

      {/* IMAGES */}
      {survey?.survey_docs?.length > 0 && (
        <>
          <h3>Survey Images</h3>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
            {survey.survey_docs.map((doc, i) => (
                <div key={i} style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontWeight: "bold", marginBottom: 5 }}>
                        {`${i+1}. ${data?.doc_master?.find(v=> v.id === doc.doc_id)?.name}`}
                    </span>
                    <img
                        src={doc.doc_path}
                        width="540"
                        height={600}
                        alt={doc.doc_name || "doc"}
                        crossOrigin="anonymous"
                    />
                </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SurveyPDF;